import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import axios from "axios";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { FaCogs, FaDollarSign, FaLightbulb, FaRoad, FaBook, FaSyncAlt, FaBinoculars, FaShieldAlt, FaLeaf, FaIndustry } from "react-icons/fa";
import Loader from "../Components/Loader"; // <-- import your loader

  const API_BASE = process.env.REACT_APP_API_BASE;
  
const SpeakerForm = () => {
  const [country] = useState("us"); // default to US
  const [submitting, setSubmitting] = useState(false); // loader state

  // Validation schema (ONLY ADDED FIELDS)
  const validationSchema = Yup.object({
    firstName: Yup.string().required("**First Name is required"),
    lastName: Yup.string().required("**Last Name is required"),
    email: Yup.string().email("**Invalid email").required("**Email is required"),
   phone: Yup.string().required("**Phone is required"),
    company: Yup.string().required("**Company is required"),
    position: Yup.string().required("**Position is required"),
    message: Yup.string().required("**Message is required"),
  });


  // Submit handler (UNCHANGED)
  const handleSubmit = async (values, { resetForm }) => {
    try {
      setSubmitting(true); // show loader
      const res = await axios.post(`${API_BASE}/fspeakers`, values);


      if (res.data.success) {
        alert(res.data.message || "Form submitted successfully!");
        resetForm();
      } else {
        alert(res.data.error || "Submission failed. Please try again.");
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong! Please try again later.");
    } finally {
      setSubmitting(false); // hide loader
    }
  };

  return (
    <div>
      {submitting && <Loader />} {/* show loader overlay */}

      <section
        className="pb-0 overflow-visible d-block position-relative z-1"
        style={{ marginBottom: "100px", padding: "80px 0", fontFamily: "'Inter', sans-serif" }}
      >
        <div className="container">
          <div className="row">
            {/* LEFT SIDE Topics */}
            <div className="col-lg-8 px-4 mb-2">
              <h2 style={{ fontWeight: "800", marginBottom: "20px", fontSize: "2.2rem", letterSpacing: "-0.5px" }}>
                Calling All Speakers
              </h2>
              <p style={{ marginBottom: "50px", fontSize: "1.05rem", lineHeight: "1.8", color: "#444" }}>
                Be a Voice at FutureOil 2026 - the premier virtual event on digital transformation in the energy sector, featuring cutting-edge themes and key topics:
              </p>

              <div className="row g-4">
                {[
                  { icon: <FaCogs size={22} />, title: "Impact and Performance", desc: "Present how real-time applications, robotics, and smart automation reduce downtime and improve safety and productivity across upstream and downstream operations." },
                  { icon: <FaDollarSign size={22} />, title: "Invest in Digitalization", desc: "Explore investment strategies and ROI in AI/ML, IoT, Big Data, Wearables, Cloud Platforms, and Cybersecurity as pillars of autonomous operations." },
                  { icon: <FaLightbulb size={22} />, title: "Opportunities & Challenges", desc: "Discuss practical strategies, lessons learned, and emerging solutions for building and scaling immersive learning and training systems across energy operations." },
                  { icon: <FaRoad size={22} />, title: "Strategic Digital Roadmaps", desc: "Guide E&P companies in assessing workflows and identifying digital leaps to align operational execution with strategic business goals." },
                  { icon: <FaBook size={22} />, title: "Digital Case Studies", desc: "Share real-world examples of successful digital transformation—showcasing the alignment of technology with tangible business outcomes." },
                  { icon: <FaSyncAlt size={22} />, title: "Leveraging Digital Transformation", desc: "Delve into change management, digital leadership, and optimizing digital strategies for long-term value creation and ROI." },
                  { icon: <FaBinoculars size={22} />, title: "Exploration Technology Innovations", desc: "Highlight cutting-edge tools in seismic imaging, remote sensing, and AI-powered analytics that are unlocking new reserves and minimizing exploration risk." },
                  { icon: <FaShieldAlt size={22} />, title: "Cybersecurity & Risk Management", desc: "Address the growing need for risk mitigation in an increasingly connected energy environment, with a focus on secure, scalable digital assets." },
                  { icon: <FaLeaf size={22} />, title: "Energy Transition & Net-Zero", desc: "Discuss how digital tools are enabling decarbonization, supporting ESG goals, and driving cleaner, more sustainable energy production." },
                  { icon: <FaIndustry size={22} />, title: "Sustainable Upstream Operations", desc: "Present technologies and best practices that reduce environmental impact, improve energy efficiency, and integrate renewable solutions into upstream workflows." },
                ].map((item, index) => (
                  <div key={index} className="col-md-6 d-flex">
                    <div
                      style={{
                        width: "54px",
                        height: "54px",
                        background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)",
                        color: "#fff",
                        borderRadius: "12px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                        marginRight: "14px",
                        boxShadow: "0 4px 10px rgba(37,117,252,0.35)",
                      }}
                    >
                      {item.icon}
                    </div>
                    <div>
                      <h5 style={{ fontWeight: "700", fontSize: "1.05rem", marginBottom: "6px", color: "#222" }}>
                        {item.title}
                      </h5>
                      <p style={{ fontSize: "0.95rem", lineHeight: "1.7", color: "#555", margin: 0 }}>{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* RIGHT SIDE Form */}
            <div className="col-lg-4 px-4">
              <div
                style={{
                  position: "sticky",
                  top: "100px",
                  background: "#fff",
                  zIndex: 100,
                  boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
                  borderRadius: "16px",
                  padding: "30px",
                }}
              >
                <h4 style={{ fontWeight: "700", marginBottom: "20px", fontSize: "1.3rem", color: "#111" }}>
                  Have a topic you want to share?
                </h4>

                <Formik
                  initialValues={{
                    firstName: "",
                    lastName: "",
                    email: "",
                    phone: "",
                    company: "",
                    position: "",
                    message: "",
                  }}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                >
                  {({ isSubmitting, setFieldValue, values }) => (
                    <Form>
                      <Field
                        name="firstName"
                        placeholder="First Name *"
                        className="form-control mb-3"
                        style={{ borderRadius: "10px", padding: "12px", fontSize: "0.95rem" }}
                      />
                      <ErrorMessage name="firstName" component="div" style={{ color: "red", fontSize: "0.8rem" }} />

                      <Field
                        name="lastName"
                        placeholder="Last Name *"
                        className="form-control mb-3"
                        style={{ borderRadius: "10px", padding: "12px", fontSize: "0.95rem" }}
                      />
                      <ErrorMessage name="lastName" component="div" style={{ color: "red", fontSize: "0.8rem" }} />

                      <Field
                        name="email"
                        type="email"
                        placeholder="Email address *"
                        className="form-control mb-3"
                        style={{ borderRadius: "10px", padding: "12px", fontSize: "0.95rem" }}
                      />
                      <ErrorMessage name="email" component="div" style={{ color: "red", fontSize: "0.8rem" }} />

                      <div className="mb-3">
                        <PhoneInput
                          country={country}
                          value={values.phone}
                          onChange={(val) => setFieldValue("phone", val)}
                          enableSearch
                          placeholder="Phone (optional)"
                          inputStyle={{
                            width: "100%",
                            height: "50px",
                            borderRadius: "10px",
                            paddingLeft: "60px",
                            fontSize: "1rem",
                            border: "1px solid #ccc",
                          }}
                          buttonStyle={{ borderRadius: "10px 0 0 10px", border: "none", background: "transparent" }}
                          containerStyle={{ width: "100%" }}
                        />
                      </div>

                      {/* 🔥 ADDED FIELDS — NO UI CHANGE */}
                      <Field
                        name="company"
                        placeholder="Company *"
                        className="form-control mb-3"
                        style={{ borderRadius: "10px", padding: "12px", fontSize: "0.95rem" }}
                      />
                      <ErrorMessage name="company" component="div" style={{ color: "red", fontSize: "0.8rem" }} />

                      <Field
                        name="position"
                        placeholder="Position *"
                        className="form-control mb-3"
                        style={{ borderRadius: "10px", padding: "12px", fontSize: "0.95rem" }}
                      />
                      <ErrorMessage name="position" component="div" style={{ color: "red", fontSize: "0.8rem" }} />

                      <Field
                        as="textarea"
                        name="message"
                        rows="4"
                        placeholder="Briefly describe your topic *"
                        className="form-control mb-3"
                        style={{ borderRadius: "10px", padding: "12px", fontSize: "0.95rem" }}
                      />
                      <ErrorMessage name="message" component="div" style={{ color: "red", fontSize: "0.8rem" }} />

                      <button
                        type="submit"
                        disabled={isSubmitting || submitting}
                        className="btn w-100"
                        style={{
                          borderRadius: "10px",
                          padding: "12px",
                          fontWeight: "600",
                          fontSize: "1rem",
                          background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)",
                          color: "#fff",
                          border: "none",
                          boxShadow: "0 4px 10px rgba(106,17,203,0.3)",
                        }}
                      >
                        {isSubmitting || submitting ? "Submitting..." : "Sign Up"}
                      </button>

                      <p style={{ marginTop: "15px", fontSize: "0.8rem", color: "#6c757d", lineHeight: "1.5" }}>
                        By proceeding, you're agreeing to receive communications from Futureoilconference and/or its affiliates, in accordance with our Terms of Use and Privacy Policy.
                      </p>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SpeakerForm;
